import { useUser } from "../../../contexts/UserContext";
import { useCustomization } from "../../../contexts/CustomizationContext";

import "./TextOptions.css";
import { FontStyle } from "@mythic/pixl";

const FONT_FAMILIES = [
    "Arial",
    "BrunoAce",
    "OneBit",
    "ContraMuerta",
    "EvilVampire",
    "Goldeneye",
    "IMFellEnglish",
    "JanuarySnack",
    "Magnetar",
    "MidnightLetters",
    "Moodcake",
    "Astroneer",
    "NewHope",
    "NewMan",
    "SuperShake",
    "Testament",
];

export default function TextOptions() {
    const { user } = useUser();
    const { font, setFont } = useCustomization();

    return (
        <div className="text-options-container">
            {FONT_FAMILIES.map((fontFamily, i) => {
                return (
                    <button
                        className={`text-option-button ${
                            font && font.name === fontFamily ? "selected" : ""
                        }`}
                        style={{ fontFamily: fontFamily }}
                        key={fontFamily}
                        onClick={() => {
                            setFont({ ...font, name: fontFamily } as FontStyle);
                        }}
                        title={fontFamily}
                    >
                        {user?.displayName ?? ""}
                    </button>
                );
            })}
        </div>
    );
}
